var map = {
	"./Facebook.svg": 1012,
	"./Instagram.svg": 1013,
	"./LinkedIn.svg": 1014,
	"./Medium.svg": 1015,
	"./Pinterest.svg": 1016,
	"./Telegram.svg": 1017,
	"./Twitter.svg": 1018,
	"./Wechat.svg": 1019,
	"./Youtube.svg": 1020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1011;